import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '@/constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    tvStations: [],
    blackoutContents: [],
    blackoutContentsMetadata: {},
    blackoutContent: {},
    blackoutContentMetadata: {}
  }
})
  .get({
    action: 'getBlackoutContents',
    property: 'blackoutContents',
    queryParams: true,
    path: '/blackout-contents/',
    onSuccess: payloadToState('blackoutContents')
  })
  .get({
    action: 'getTvStationsWithBlackout',
    property: 'tvStations',
    queryParams: true,
    path: '/blackout-contents/tv-stations',
    onSuccess: payloadToState('tvStations')
  })
  .post({
    action: 'createBlackoutContent',
    property: 'blackoutContent',
    path: '/blackout-content/',
    onSuccess: payloadToState('blackoutContent')
  })
  .get({
    action: 'getBlackoutContent',
    property: 'blackoutContent',
    path: ({ id }) => `/blackout-contents/${id}`,
    onSuccess: payloadToState('blackoutContent')
  })
  .put({
    action: 'updateBlackoutContent',
    property: 'blackoutContent',
    path: ({ id }) => `/blackout-contents/${id}`,
    onSuccess: payloadToState('blackoutContent')
  })
  .delete({
    action: 'deleteBlackoutContent',
    property: 'blackoutContent',
    path: ({ id }) => `/blackout-contents/${id}`,
    beforeRequest: getOptimisticDelete('blackoutContents'),
    onSuccess: payloadToState('blackoutContent')
  })
  .getStore()
